module.exports = __webpack_public_path__ + "static/img/mould3.3dc196f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/devops/mould/mould3.png
// module id = w1SK
// module chunks = 3